import { connect } from 'react-redux';
import Filters from './Filters';
import { setFilters } from './store/filtersSlice';
import { setAuthorizationBy } from '../self-authorizations/store/createNewSelfAuthorizationSlice';

const mapState = state => ({
  authType: state.loadingManagement.filters.authType,
  relatedIds: state.loadingManagement.filters.relatedIds,
  searchTerm: state.loadingManagement.filters.searchTerm,
  selectedIndex: state.loadingManagement.filters.selectedIndex,
});

const mapDispatchToProps = {
  setAuthorizationBy,
  setFilters,
};

export default connect(mapState, mapDispatchToProps)(Filters);
